/**
 * Чистые операции над порядком слайдов презентации.
 * Используются API (вычисление sortOrder при create/duplicate, валидация reorder)
 * и web (optimistic-обновления списка, undo/redo). Одна реализация — одинаковое
 * поведение на клиенте и сервере.
 */

/**
 * Вставляет `newId` сразу после `afterId`. Если `afterId` не задан или не найден
 * (слайд могли удалить параллельно) — добавляет в конец.
 */
export function insertIdAfter(
  orderedIds: readonly string[],
  newId: string,
  afterId?: string | null,
): string[] {
  const index = afterId ? orderedIds.indexOf(afterId) : -1;
  if (index === -1) {
    return [...orderedIds, newId];
  }
  return [...orderedIds.slice(0, index + 1), newId, ...orderedIds.slice(index + 1)];
}

/**
 * Проверяет, что два списка содержат один и тот же набор id без дубликатов.
 * Защита reorder: клиент обязан прислать все слайды ровно по одному разу,
 * иначе часть слайдов потеряла бы порядок.
 */
export function isSameIdSet(a: readonly string[], b: readonly string[]): boolean {
  if (a.length !== b.length) {
    return false;
  }
  const setA = new Set(a);
  if (setA.size !== a.length) {
    return false;
  }
  return b.every((id) => setA.has(id)) && new Set(b).size === b.length;
}
